// Height of the word panel in VH units
export const wordPanelHeight = 32;

// Size of the card in VH units
export const cardSize = 16;

// Maximum horizontal gap (in addition to the minimum gap) between cards in VH units
export const maxCardGap = 4;